import Vue from 'vue';
import axios from 'axios';
import {hasPermission} from "../../utils/permissions";

// initial state
const state = {
  ticketCount: 0,
  unreadTickets: [],
  user_logo: {},
  ticket: {},
  supportTicket: {},
  amazon_url: '',
  imap_url: '',
  amazon_profile_url:'',
  tickets: [],
  ticketsSearch: [],
  totalPages: 0,
  totalTickets:0,
  ticketsPerPage:0,
  supportTicketsPerPage:0,
  boardList:[],
}

// getters
const getters = {
  user_logo: (state) => {
    return state.user_logo;
  },
  ticket: (state) => {
    return state.ticket;
  },
  supportTicket: (state) => {
    return state.supportTicket;
  },
  amazon_url: (state) => {
    return state.amazon_url;
  },
  imap_url: (state) => {
    return state.imap_url;
  },
  amazon_profile_url: (state) => {
    return state.amazon_profile_url;
  },
  tickets: (state) => {
    return state.tickets;
  },
  totalPages: (state) => {
    return state.totalPages;
  },
  ticketsSearch: (state) => {
    return state.ticketsSearch;
  },
  totalTickets: (state)=> {
    return state.totalTickets;
  },
  ticketsPerPage: (state)=> {
    return state.ticketsPerPage;
  },
  supportTicketsPerPage: (state) => {
    return state.supportTicketsPerPage;
  }
}

// mutations
const mutations = {
  SET_TICKET_COUNT(state, count) {
    state.ticketCount = count;
  },
  SET_UNREAD_TICKETS(state, tickets) {
    state.unreadTickets = tickets;
  },
  SET_USER_LOGO(state, user_logo) {
    state.user_logo = user_logo;
  },
  SET_TICKET(state, ticket) {
    state.ticket = ticket;
  },
  SET_SUPPORT_TICKET(state, ticket) {
    state.supportTicket = ticket;
  },
  SET_AWS_URL(state, aws_url) {
    state.amazon_url = aws_url;
  },
  SET_IMAP_URL(state, imap_url) {
    state.imap_url = imap_url;
  },
  SET_AWS_PROFILE_URL(state, profile_url){
    state.amazon_profile_url = profile_url
  },
  SET_TICKETS(state, tickets) {
    state.tickets = tickets;
  },

  SET_TICKETS_SEARCH(state, tickets) {
    state.ticketsSearch = tickets;
  },

  SET_TOTAL_PAGES(state, totalPages) {
    state.totalPages = totalPages;
  },

  DELETE_TICKET(state, ticket) {
    let ticketIndex = state.tickets.findIndex((item) => {
      return item.id === ticket.id;
    });

    if (ticketIndex > -1) {
      state.tickets.splice(ticketIndex, 1);
    }
  },
  SET_TOTAL_TICKETS(state, totalTickets) {
    state.totalTickets = totalTickets;
  },
  SET_TICKETS_PER_PAGE(state, supportTicketsPerPage) {
    state.supportTicketsPerPage = supportTicketsPerPage;
  },
  SET_TOTAL_TICKETS_PER_PAGE(state, ticketsPerPage) {
    state.ticketsPerPage = ticketsPerPage;
  },


  // UPDATE_USER(state, user) {
  //   let userIndex = state.users.findIndex((item) => {
  //     return item.id == user.id;
  //   });
  //   Vue.set(state.users, userIndex, user);
  // },

  // DELETE_USER(state, user) {
  //   let index = state.users.indexOf(user);
  //   if (index > -1) {
  //     state.users.splice(index, 1);
  //   }
  // },
}

// actions
const actions = {
  getAllTickets({commit}, [page ,status,search,category,organization='',category_search='']) {
    if(hasPermission('all_tickets_list')){
      const permission = {
        headers: {
          'X-Permission': 'all_tickets_list' // Setting the custom header
        }
      };
      axios.get('/admin/support/ticket?page=' + page +'&status='+status+'&search='+search+'&category='+category+"&organization="+organization+"&category_search="+category_search,permission)
          .then((response) => {
            let res = response.data;
            commit('SET_TICKETS', res.data);

            let totalPages = Math.ceil(res.total / res.per_page);
            commit('SET_TOTAL_PAGES', totalPages);
            commit('SET_TOTAL_TICKETS', res.total);
            commit('SET_TICKETS_PER_PAGE', res.data.length);
            commit('SET_TOTAL_TICKETS_PER_PAGE', res.per_page);
          });
    }
  },
  searchTickets({commit}, query) {
    return axios.get('/admin/support/search?q=' + query)
      .then((response) => {
        // commit('SET_TICKETS_SEARCH', response.data);
        commit('SET_TICKETS_SEARCH', response.data.data);
      });
  },
  async getTicket({commit}, ticket_id) {  
                             
    const response = await axios.get('/admin/support/ticket/' + ticket_id);                            
    commit('SET_TICKET', response.data.ticket);
  //  commit('SET_USER_LOGO', response.data.user_logo[0].logo);
  },
  async getSuportTicket({commit}, [ticket_id, org_id]) {
    if(hasPermission('all_tickets_view')){
      const permission = {
        headers: {
          'X-Permission': 'all_tickets_view'
        }
      };
      const response = await axios.get('/admin/support/get-ticket/' + ticket_id  + '/' + org_id,permission);
      commit('SET_SUPPORT_TICKET', response.data.ticket);
      commit('SET_AWS_URL',response.data.aws);
      commit('SET_IMAP_URL',response.data.imap_attachment_aws_url);
      commit('SET_AWS_PROFILE_URL',response.data.profile_aws);
      commit('SET_USER_LOGO', response.data.user_logo);
    }
  },

  deleteTicket({commit}, ticket) {
    if(hasPermission('all_tickets_delete')){
      const permission = {
        headers: {
          'X-Permission': 'all_tickets_delete'
        }
      };
      return axios.post('/admin/support/ticket/' + ticket.id + '?_method=DELETE', null, permission)
          .then((response) => {
            commit('DELETE_TICKET', ticket);
            return response.data.message;
          });
    }
  },
 
  changeTicketStatus({commit}, data) {
    if(hasPermission('all_tickets_list')){
      const permission = {
        headers: {
          'X-Permission': 'all_tickets_list'
        }
      };

      axios.post('/admin/support/change-ticket-status/' + data.ticket_id + '/' + data.status, {
        '_method': 'POST'
      },permission)
          .then((response) => {
            return response;
          });
    }
  },
  changeTicketDeliveryDate({commit}, data) {
    if(hasPermission('all_tickets_view')){
      const permission = {
        headers: {
          'X-Permission': 'all_tickets_view'
        }
      };
      axios.post('/admin/support/change-ticket-delivery-date/' + data.ticket_id, {
        '_method': 'POST',
        'delivery_date': data.delivery_date
      },permission)
          .then((response) => {
            return response;
          });
    }
  },
  addCard ({}, ticket) {
    let formData = new FormData();
    formData.append('ticket_id', ticket.ticket_id);
    formData.append('list_id', ticket.list_id);
    formData.append('list_card_title', ticket.list_card_title);
    formData.append('list_card_desc', ticket.list_card_desc);

    return axios.post('/admin/support/moveCard/' +  ticket.ticket_id, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then((response) => {
      return response;
    })
  },
  sendReply ({}, ticket) {
    let formData = new FormData();
    formData.append('message', ticket.message);
    formData.append('id', ticket.id);
    formData.append('user_id', ticket.user_id);
    formData.append('title', ticket.title);
    formData.append('category', ticket.category);
    formData.append('unique_folder', ticket.unique_folder);
    // trello cart data
    if (ticket.id == 0) {
      formData.append('add_trello', ticket.add_trello);
      formData.append('list_id', ticket.list_id);
      formData.append('org_id', ticket.org.organization_id);
      formData.append('list_card_title', ticket.list_card_title);
      formData.append('list_card_desc', ticket.list_card_desc);
      formData.append('customer_feedback', 0);

    }else{
      formData.append('org_id', ticket.org_id);
      formData.append('customer_feedback', ticket.customer_feedback ? 1 : 0);
    }

    if (typeof ticket.attachment !== undefined) {
      for (var i = 0; i < ticket.attachment.length; i++) {
        formData.append("attachment[]", ticket.attachment[i]);
      }
    }
    if(hasPermission('all_tickets_view')){
      const permission = {
        headers: {
          'X-Permission': 'all_tickets_view'
        }
      };
      return axios.post('/admin/support/sendReply/' + ticket.id, formData, permission,{
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
          .then((response) => {
            return 'Message has been sent successfully';
          })
    }
  },
  async viewticket({ commit, dispatch }, { id, org_id }) {
    if(hasPermission('all_tickets_view')){
      try {
        const permission = {
          headers: {
            'X-Permission': 'all_tickets_view'
          }
        };
        const response = await axios.get("/admin/support/get-ticket/" + id + '/' + org_id,permission);
        const message = response.data.ticket;
        await dispatch('setUnreadTicketsCount');
        return message;
      } catch (error) {
        console.error('Error fetching ticket:', error);
        throw error;
      }
    }
},
  async setUnreadTicketsCount({ commit }) {
    if(hasPermission('all_tickets_list')){
      try {
        const permission = {
          headers: {
            'X-Permission': 'all_tickets_list'
          }
        };
        const response = await axios.get('/admin/support/unread-tickets-count',permission);
        if (response.data.ticket_count !== undefined && response.data.ticket_count > 0) {
          commit('SET_TICKET_COUNT', response.data.ticket_count);
          commit('SET_UNREAD_TICKETS', response.data.unread_tickets);


        } else {
          commit('SET_TICKET_COUNT', '');
          commit('SET_UNREAD_TICKETS', []);
        }
      } catch (error) {
        console.error('Error fetching unread tickets count:', error);

      }
    }
  },

  async ticketIndevelopment({},[formData]){
    return  await axios.post('/admin/support/ticket-indevelopment/'+formData.ticket_id,{formData:formData}).then((response)=>{
      return response.data;
    });
  },

  async saveComment( {},[support_comment, ticket_id, tag_user, lead_id, organization_id, message_id= null]) {
    if(hasPermission('all_tickets_list')){
      const permission = {
        headers: {
          'X-Permission': 'all_tickets_list'
        }
      };

      return await axios.post('/admin/support/create-ticket/comment', {
        support_comment: support_comment,
        ticket_id: ticket_id,
        tag_user: tag_user,
        lead_id: lead_id,
        organization_id: organization_id,
        message_id: message_id
      }, permission).then((response) => {
        return response.data;
      });
    }
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
